import { createSlice } from '@reduxjs/toolkit';
import { activityAnswer } from '../api/activities';
const initialState = {
  book: {
    _id: '1',
    title: '',
    name: '',
    author: '',
    coverImage: '',
    description: '',
    subject: '',
    chapters: [
      {
        title: '',
        description: '',
        sections: [{ title: '', description: '', paragraphs: [{}] }],
      },
    ],
    activities: [],
    activitiesByAssignedDate: [],
    activitiesSet: null,
    allClassSection: [],
    classSection: null,
    ClassId: '',
    filterdClassData: [],
  },
};

const slice = createSlice({
  name: 'activities',
  initialState,

  reducers: {
    setActivities: (state, action) => {
      state.book.activities = action.payload;
    },
    setBook: (state, action) => {
      state.book._id = action.payload._id;
      state.book.name = action.payload.title;
      state.book.author = action.payload.author || 'SHOOK ET AL';
      state.book.subject = action.payload.subject;
      state.book.coverImage = action.payload.coverImage;
      state.book.activitiesSet = action.payload.activitiesSet;
      state.book.owner = action.payload.owner;
    },
    setBookChapters: (state, action) => {
      state.book.chapters = action.payload;
    },
    setActivitiesByAssignedDate: (state, action) => {
      state.book.activitiesByAssignedDate = action.payload;
    },
    setAllClassSection: (state, action) => {
      state.book.allClassSection = action.payload;
    },
    setClassId: (state, action) => {
      state.book.ClassId = action.payload;
    },
    setClassSection: (state, action) => {
      state.book.classSection = action.payload;
    },

    updateActivityAnswer: (state, action) => {
      const date = action.payload.date;
      const id = action.payload.id;
      const answer = action.payload.answer;
      const newAnswersByDate = state.book.activitiesByAssignedDate.map((e, i) =>
        new Date(e.assignedDate).setHours(0, 0, 0, 0) !== new Date(date).setHours(0, 0, 0, 0)
          ? e
          : {
              ...e,
              activities: e.activities.map((activity, aIndex) =>
                id !== activity._id
                  ? activity
                  : {
                      ...activity,
                      activityAnswers: [answer],
                    }
              ),
            }
      );
      state.book.activitiesByAssignedDate = newAnswersByDate;
    },

    filterdClassDatabyId: (state, action) => {
      const { id } = action.payload;
      state.book.ClassId = id;
      const filter = state.book.allClassSection.filter((item) => item._id === id);
      state.filterdClassData = filter;
    },
  },
});

export const { setActivities, setBook, setBookChapters, setActivitiesByAssignedDate, setAllClassSection, setClassSection, setClassId, filterdClassDatabyId, updateActivityAnswer } = slice.actions;
export default slice.reducer;
